const pcnemailsettings = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Mail Settings",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "Mail Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "onlineServicesTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    sender_email: {
                      type: "text",
                      label: "Sender Address",
                      placeholder: "Enter Email",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    default_email: {
                      type: "text",
                      label: "Default Recipient Address",
                      placeholder: "Enter Email",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    referrals: {
                      type: "heading",
                      label: "Referrals",
                      size: "12",
                    },
                    pcn_referral_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "PCN Referral Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    social_prescribing_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Social Prescribing Form",
                      placeholder: "Social Prescribing Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "8",
                      style: "",
                    },
                    pcn_referral_form_email: {
                      type: "text",
                      label: "pcn_referral_form_check",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "pcn_referral_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    social_prescribing_form_email: {
                      type: "text",
                      label: "social_prescribing_form_check",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "social_prescribing_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    patient_feedback: {
                      type: "heading",
                      label: "Patient Feedback",
                      size: "12",
                    },
                    feedback_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Feedback Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    feedback_form_disable_email: {
                      type: "mailSettingsCheckbox",
                      label: "Disable email",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    complaints_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Complaints Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "8",
                      style: "",
                    },
                    feedback_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "feedback_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    complaints_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "complaints_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { pcnemailsettings };
